import { render } from "./LayContent.vue?vue&type=template&id=e54a3190&scoped=true"
import script from "./LayContent.vue?vue&type=script&lang=js"
export * from "./LayContent.vue?vue&type=script&lang=js"

import "./LayContent.vue?vue&type=style&index=0&id=e54a3190&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e54a3190"]])

export default __exports__